import React from 'react';
import styles from './styles.scss';

type BackButtonProps = {
  onClick: () => void;
};

export const BackButton = ({ onClick }: BackButtonProps) => {
  return (
    <button
      type="button"
      className={styles.previewMode_closeButton}
      onClick={onClick}
    >
      <span className="sr-only">Close panel</span>
      <img src="/assets/images/arrow_left.svg" alt="Close icon" />
    </button>
  );
};
